import { useState, useSyncExternalStore } from 'react';
import { toast } from 'react-toastify';
import { openErrorCount, subscribeOpenErrors, closeAllErrors } from '../utils/toastSetup';

/** Copies text, with a fallback for browsers or pages where the clipboard API is not allowed. */
async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(area);
    return ok;
  }
}

/**
 * The body of an error message: the message itself (selectable), how many times it happened if more than once,
 * when it last happened, a Copy button (message, time and page, for a support request) and, when several errors
 * are open, Close all.
 */
function ErrorToast({ message, time, count, page }) {
  const [copied, setCopied] = useState(false);
  const openErrors = useSyncExternalStore(subscribeOpenErrors, openErrorCount);

  const copy = async (e) => {
    e.stopPropagation();
    const ok = await copyText(`${message}\n${time.toLocaleString()} · ${page}`);
    if (ok) {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } else {
      toast.info('Could not copy. Select the message text and copy it instead.');
    }
  };

  return (
    <div className="error-toast">
      <div className="error-toast-message">
        {message}
        {count > 1 && <span className="error-toast-count" title={`Happened ${count} times`}>×{count}</span>}
      </div>
      <div className="error-toast-meta">
        <span>{time.toLocaleTimeString()}</span>
        <button type="button" className="error-toast-action" onClick={copy}>
          <i className={`bi ${copied ? 'bi-check2' : 'bi-clipboard'} me-1`} aria-hidden="true" />
          {copied ? 'Copied' : 'Copy'}
        </button>
        {openErrors > 1 && (
          <button type="button" className="error-toast-action" onClick={(e) => { e.stopPropagation(); closeAllErrors(); }}>
            Close all
          </button>
        )}
      </div>
    </div>
  );
}

export default ErrorToast;
